// test2226
(2226 && 0);
